import { connect } from 'react-redux';
import {
  fetchGreatDealsNewArrivals,
  fetchBillboardImages,
  updateGreatDeals,
  updateNewArrivals,
  saveBillboardImages,
  deleteBillboardImage,
} from '../../actions/mobileManagement_actions';

import MobileManagement from '../../components/General/MobileManagement';

function mapStateToProps(state) {
  return {
    productList: state.mobileManagement.productList,
    productListIsLoading: state.mobileManagement.productListIsLoading,
    productListError: state.mobileManagement.productListError,
    isGreatDealsUpdating: state.mobileManagement.isGreatDealsUpdating,
    isGreatDealsUpdated: state.mobileManagement.isGreatDealsUpdated,
    updateGreatDealsError: state.mobileManagement.updateGreatDealsError,
    isNewArrivalsUpdating: state.mobileManagement.isNewArrivalsUpdating,
    isNewArrivalsUpdated: state.mobileManagement.isNewArrivalsUpdated,
    updateNewArrivalsError: state.mobileManagement.updateNewArrivalsError,
    isUpdating: state.mobileManagement.isGreatDealsUpdating || state.mobileManagement.isNewArrivalsUpdating,
    isUpdated: state.mobileManagement.isGreatDealsUpdated && state.mobileManagement.isNewArrivalsUpdated,
    billboardImagesList: state.mobileManagement.billboardImagesList,
    billboardImagesIsLoading: state.mobileManagement.billboardImagesIsLoading,
    billboardImagesError: state.mobileManagement.billboardImagesError,
    savingBillboardImages: state.mobileManagement.savingBillboardImages,
    saveBillboardImagesSuccess: state.mobileManagement.saveBillboardImagesSuccess,
    deletingBillboardImage: state.mobileManagement.deletingBillboardImage,
  };
}

export default connect(mapStateToProps, {
  fetchGreatDealsNewArrivals,
  fetchBillboardImages,
  updateGreatDeals,
  updateNewArrivals,
  saveBillboardImages,
  deleteBillboardImage,
})(MobileManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/MobileManagement.jsx